<template>
  <div>
    <div class="assignment" v-for="(value, index) in assignments" :key="index"
      v-bind:class="[ isBlock ? 'block' : 'inline' ]"
      @click="openAssignmentViewer(value.viewer_url)">
      <div class="assignment-cover-container">
        <img :src="value.assigned_card.cover_image" class="assignment-cover" alt="cover">
        <div class="assignment-gradient"></div>
      </div>
      <div class="assignment-description">
        <img :src="value.assigned_by_profile_image" class="assignment-profile" alt="profile-image">
        <div class="assignment-title">{{ value.assigned_card.title }}</div>
        <div class="assignment-subtitle">{{ value.assigned_card.grade_name }} {{ value.assigned_card.subject_name }} {{ value.assigned_card.chapter_name }}</div>        
      </div>
      <div class="assignment-date" v-bind:style="{ 'color': dueDate(value.due_date).color }">
        <strong v-if="remainingDay(value.due_date)">D-{{ remainingDay(value.due_date) }}</strong> {{ dueDate(value.due_date).dueDate }}
      </div>
      <div class="assignment-state" v-if="isBlock">
        <div class="assignment-state-active" v-if="isDueDate(value.due_date) && !isSubmitted(value.submissions)">
          {{ $t('assignment.assignment_solve') }}
        </div>

        <div class="assignment-state-graded" v-if="!isGraded(value.submissions) && isSubmitted(value.submissions)">
          {{ $t('assignment.stats.in_review_count') }}
        </div>

        <div class="assignment-state-score" v-if="isGraded(value.submissions) && isSubmitted(value.submissions)">
          <template>{{ $t('assignment.user') }} <span>{{ userScore(value) }}</span>{{ $t('common.score_value')}}</template>
          <template>{{ $t('assignment.class') }} <span>{{ classScore(value) }}</span>{{ $t('common.score_value')}}</template>
        </div>

        <div class="assignment-state-score" v-if="!isDueDate(value.due_date) && !isSubmitted(value.submissions)">
          <template>{{ $t('assignment.non_submission') }}</template>
          <template>{{ $t('assignment.class') }} <span>{{ classScore(value) }}</span>{{ $t('common.score_value')}}</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment/src/moment';

  export default {
    name: 'assignment',

    props: [
      'assignments',
      'isBlock',
      'eventLabel',
    ],

    methods: {
      openAssignmentViewer(url) {
        this.$ga.event({
          eventCategory: 'assignments',
          eventAction: 'click',
          eventLabel: this.eventLabel,
        });

        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(url);
        }
        return window.open(url);
      },

      isDueDate(date) {
        return moment(date).valueOf() > moment().valueOf();
      },

      dueDate(date) {
        if (this.isDueDate(date)) {
          if (Math.round(moment(date).diff(moment(), 'days', true)) <= 2) {
            return {
              dueDate: this.$t('assignment.period_submission', { date: moment(date).format('YYYY.MM.DD HH:mm:ss') }),
              color: '#ff595f',
            };
          }

          return {
            dueDate: this.$t('assignment.period_submission', { date: moment(date).format('YYYY.MM.DD HH:mm:ss') }),
            color: '#00c896',
          };
        }

        return {
          dueDate: this.$t('assignment.end_submission', { date: moment(date).format('YYYY.MM.DD HH:mm:ss') }),
          color: '#aaaaaa',
        };
      },

      remainingDay(date) {
        if (!this.isDueDate(date)) {
          return false;
        }

        return Math.round(moment(date).diff(moment(), 'days', true));
      },

      isGraded(submissions) {
        return submissions[0].is_graded;
      },

      isSubmitted(submissions) {
        return submissions[0].is_submitted;
      },

      userScore(value) {
        return (value.score && value.score.my_score) || '-';
      },

      classScore(value) {
        return (value.score && value.score.class_score) || '-';
      },

    },
  };
</script>

<style lang="scss" scoped>
  .assignment {
    background-color: #ffffff;
    border-radius: 4px;
    display: inline-block;
    cursor: pointer;

    &:hover {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    }
    .assignment-cover-container {
      position: relative;

      .assignment-cover {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        width: 100%;
        height: 120px;
        object-fit: cover;
      }

      .assignment-gradient {
        background-image: linear-gradient(to bottom, rgba(255,255,255,0), rgba(0,0,0,0.15));
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        height: 14px;
      }

    }

    .assignment-description {
      padding: 14px;
      position: relative;

      .assignment-profile {
        width: 32px;
        height: 32px;
        background-color: #ffffff;
        border: solid 1px #d9d9d9;
        border-radius: 32px;
        position: absolute;
        right: 14px;
        top: -18px;
      }
      
      .assignment-title {
        font-size: 16px;
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
      }

      .assignment-subtitle {
        color: #aaaaaa;
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
        height: 20px;
      }
    }

    .assignment-date {
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      padding: 0px 14px 14px 14px;
    }

    .assignment-state {
      float: right;
      margin-right: 14px;

      .assignment-state-score {
        color: #aaaaaa;

        span {
          color: #00c896;
        }
      }

      .assignment-state-active {
        color: #00c896;
      }

      .assignment-state-graded {
        color: #aaaaaa;
      }
    }

  }

  .inline {
    width: 220px; 
    display: inline-block;
    margin: 14px 6px 14px 6px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  }

  .block {
    width: 100%;
    display: block;
    margin: 12px 0px 12px 0px;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
  }
</style>


// WEBPACK FOOTER //
// Assignment.vue?affe1e64